module.exports = __webpack_public_path__ + "img/industry-dong.e93edd3e.jpg";